export const styledInputBase = () => {
  return { width: '100%', marginTop: '7px' };
};
